export default __webpack_public_path__ + "static/media/Harness of the Howling Giant.9d790366.jpg";